import React from 'react';
// import Switch from '@material-ui/core/Switch';
import Switch from "react-switch";
function SwitchCont(props) {
    return (
        // <div className={styles.switch_cont}>
        <Switch
            onColor="#00696B"
            checked={props.value}
            disabled={props.disabled}
            name={props.name}
            height={14}
            width={34}
            handleDiameter={20}
            // value={props.value}
            onChange={(e) => {
                props.handleChange(e)
            }} />
        // </div>
    )
}
export default SwitchCont;